import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useState } from 'react';
import { Typography, styled } from '@mui/material';
import { useRef } from 'react';
import './TimePickerCC.css';
export const convertSecondToHourAndMinute = (value) => {
    let totalSeconds = value;
    let hours = Math.floor(totalSeconds / 3600);
    let minutes = Math.floor((totalSeconds % 3600) / 60);
    let seconds = value % 60;
    let string_hours = `${hours}`;
    let string_minutes = `${minutes}`;
    let string_seconds = `${seconds}`;
    if (hours < 10) {
        string_hours = `0${hours}`;
    }
    if (minutes < 10) {
        string_minutes = `0${minutes}`;
    }
    if (seconds < 10) {
        if (seconds == 0) {
            string_seconds = `00`;
        }
        else
            string_seconds = `0${seconds}`;
    }
    return `${string_hours}:${string_minutes}:${string_seconds}`;
};
export const convertHourAndMinToSecond = (value) => {
    let validTime = /^(0[0-9]|1[0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9]$/;
    if (validTime.test(value)) {
        var a = value.split(':'); // split it at the colons
        // minutes are worth 60 seconds. Hours are worth 60 minutes.
        var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
        return seconds;
    }
    else
        return false;
};
const arrayTime = Array.from(Array(97).keys()).filter(item => item > 0).map(item => convertSecondToHourAndMinute((item) * 900));
const filter = createFilterOptions();
const AutocompleteCC = styled(Autocomplete)({
    borderRadius: '6px',
    '& .MuiInputBase-root': {
        padding: '2px 0px 2px 2px !important',
        fontSize: '14px',
        borderRadius: '6px',
        "& input": {
            fontWeight: '500',
            paddingTop: '2px !important',
            paddingBottom: '2px !important',
            height: '24px'
        }
    },
    '& .MuiInputBase-input': {
        fontSize: '14px !important',
    },
    '& .MuiAutocomplete-clearIndicator': {
        display: 'none'
    },
    '& .MuiAutocomplete-listbox': {
        color: 'red'
    }
});
export const TimePickerCC = ({ value, setValue, validTime = true, id, disabled = false, minTime = null, maxTime = null }) => {
    const [renderValue, setRenderValue] = useState(value);
    const [options, setOptions] = useState(arrayTime);
    const [open, setOpen] = useState(false);
    const [onChangeValue, setOnChangeValue] = useState(false);
    const refValue = useRef(value);
    const handleChangeValue = (value, changeValue = false) => {
        if (changeValue) {
            setValue(value);
            setRenderValue(value);
            refValue.current = value;
            setOpen(false);
        }
        else {
            setRenderValue(refValue.current);
        }
    };
    return (React.createElement(AutocompleteCC, { className: disabled ? 'time-picker-disabled time-picker' : 'time-picker', id: id, disabled: disabled, openOnFocus: true, options: options, openText: "", value: disabled ? 'HH:mm:ss' : (renderValue || null), onChange: (event, value) => {
            let time = convertHourAndMinToSecond(value);
            //60: 1s
            //86400: 24h
            if (time) {
                if (time < 1) {
                }
                else if (time > 86400) {
                }
                else {
                    handleChangeValue(value, true);
                }
            }
        }, blurOnSelect: true, filterOptions: (options, params) => {
            const filtered = filter(options, params);
            const isExisting = options.some((option) => params.inputValue === option);
            if (params.inputValue !== '' && !isExisting) {
                filtered.push(params.inputValue);
            }
            return filtered;
        }, renderOption: (props, option, { selected }) => {
            return React.createElement(Typography, { ...props, p: 1, sx: {
                    cursor: 'pointer', color: selected ? "#FFFFFF" : "#000000", backgroundColor: selected ? `#CB002B !important` : 'auto', fontSize: '14px',
                    '&:hover': {
                        color: "#CB002B",
                        backgroundColor: `#F0F0F0 !important`
                    },
                } }, option);
        }, renderInput: (params) => React.createElement(TextField, { error: !validTime, placeholder: 'HH:mm:ss', sx: { minWidth: '100px' }, ...params }), getOptionDisabled: (option) => {
            if (minTime && option < minTime) {
                return true;
            }
            if (maxTime && option > maxTime) {
                return true;
            }
            return false;
        }, sx: [
            {
                '& .MuiButtonBase-root': {
                    marginRight: '0 !important'
                }
            }
        ] }));
};
